import { FC } from "react";
import { Path, Svg, SvgProps } from "react-native-svg";

const PdPaperAlt: FC<SvgProps> = (props) => (
  <Svg viewBox="0 0 32 32" fill="none" {...props}>
    <Path
      d="M9.5 24C9.5 23.7239 9.72386 23.5 10 23.5H22C22.2761 23.5 22.5 23.7239 22.5 24C22.5 24.2761 22.2761 24.5 22 24.5H10C9.72386 24.5 9.5 24.2761 9.5 24Z"
      fill="currentColor"
    />
    <Path
      d="M10 8.5C9.72386 8.5 9.5 8.72386 9.5 9C9.5 9.27614 9.72386 9.5 10 9.5H17C17.2761 9.5 17.5 9.27614 17.5 9C17.5 8.72386 17.2761 8.5 17 8.5H10Z"
      fill="currentColor"
    />
    <Path
      d="M9.5 12C9.5 11.7239 9.72386 11.5 10 11.5H22C22.2761 11.5 22.5 11.7239 22.5 12C22.5 12.2761 22.2761 12.5 22 12.5H10C9.72386 12.5 9.5 12.2761 9.5 12Z"
      fill="currentColor"
    />
    <Path
      d="M10 14.5C9.72386 14.5 9.5 14.7239 9.5 15C9.5 15.2761 9.72386 15.5 10 15.5H22C22.2761 15.5 22.5 15.2761 22.5 15C22.5 14.7239 22.2761 14.5 22 14.5H10Z"
      fill="currentColor"
    />
    <Path
      d="M9.5 18C9.5 17.7239 9.72386 17.5 10 17.5H22C22.2761 17.5 22.5 17.7239 22.5 18C22.5 18.2761 22.2761 18.5 22 18.5H10C9.72386 18.5 9.5 18.2761 9.5 18Z"
      fill="currentColor"
    />
    <Path
      d="M10 20.5C9.72386 20.5 9.5 20.7239 9.5 21C9.5 21.2761 9.72386 21.5 10 21.5H22C22.2761 21.5 22.5 21.2761 22.5 21C22.5 20.7239 22.2761 20.5 22 20.5H10Z"
      fill="currentColor"
    />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 5C7 4.44772 7.44772 4 8 4H19.6492C19.8763 4 20.0966 4.07728 20.2739 4.21913L24.6247 7.69976C24.8619 7.88953 25 8.17684 25 8.48062V27C25 27.5523 24.5523 28 24 28H8C7.44772 28 7 27.5523 7 27V5ZM24 9.01823V27H8V5H18.9901L18.0256 9.82259C17.9454 10.2235 18.3151 10.5686 18.7096 10.4611L24 9.01823ZM23.5349 8.10855L19.9601 5.24874L19.1489 9.30473L23.5349 8.10855Z"
      fill="currentColor"
    />
  </Svg>
);

export default PdPaperAlt;
